import Bowser from 'bowser';
const getUserAgent = () => window.navigator.userAgent;
export const getPlatform = () => Bowser.getParser(getUserAgent()).getPlatformType(true);
export const isDesktop = () => getPlatform() === 'desktop';
export const isMobile = () => getPlatform() === 'mobile';
export const isTablet = () => getPlatform() === 'tablet';
//# sourceMappingURL=platform.js.map